module.exports = __webpack_public_path__ + "img/mic-vintage-icon.1040e2cd.png";